export const adminToastEvent = "tb-admin-toast";

export function showAdminToast(message: string) {
  window.dispatchEvent(new CustomEvent(adminToastEvent, { detail: message }));
}
